import { jsPDF } from 'jspdf';
import { Component } from '@angular/core';
import { BasePage } from 'src/app/core/base-page';
import { Invoice } from 'src/app/data/schema/invoice';
import { CountriesInfo } from 'src/app/data/schema/countries-info';
import { DateTimeHelper } from 'src/app/core/helper/datetime.helper';
import { ModalController } from '@ionic/angular';
import { AuthenticationService } from 'src/app/core/modules/auth-core/data/service/authentication.service';
import { CurrencyHelper } from 'src/app/core/helper/currency.helper';
import { ServiceHelper } from 'src/app/core/helper/services.helper';


@Component({
  selector: 'app-invoices',
  templateUrl: './invoices.page.html',
  styleUrls: ['./invoices.page.scss'],
})
export class InvoicesPage extends BasePage {

  invoices: Invoice[] = [];
  doc: jsPDF;

  constructor(
    authService: AuthenticationService,
    private modalCtrl: ModalController,
  ) {
    super(authService);
  }

  ionViewWillEnter() {
    this.loadData();
  }

  async close() {
    await this.modalCtrl.dismiss();
  }


  async downloadInvoice(invoice: Invoice) {
    //This have to be initialized here to prevent documents being overlaped with each one
    this.doc = new jsPDF('portrait', 'in', [10.5, 8]);

    const province = CountriesInfo.Provinces.find(obj => obj.code === invoice.province);
    const country = CountriesInfo.Countries.find(obj => obj.code === invoice.country);
    const profile = this.authService.profile;

    // RR Logo
    const img = new Image();
    img.src = './assets/img/raffle-logo-address.png';
    this.doc.addImage(img, 'PNG', 0.5, 0.2, 3.3, 0.9);

    // Sales Receipt
    this.doc.setFontSize(30);
    this.doc.setTextColor('#44688B');
    this.doc.setFont('helvetica', 'bold');
    this.doc.text('Sales Receipt', 7.5, 0.7, null, 'right');
    this.doc.setFont('helvetica', 'normal');
    // Date
    this.doc.setFontSize(14);
    this.doc.text('Date:', 5.7, 1, null, 'left');
    // Today's Date
    this.doc.setTextColor('#474747');
    this.doc.text(DateTimeHelper.formatDateShort(new Date()), 7.5, 1, null, 'right');
    // Receipt No
    this.doc.setTextColor('#44688B');
    this.doc.text('Receipt #:', 5.7, 1.2, null, 'left');
    this.doc.setTextColor('#474747');
    // Raffle ID
    this.doc.text(`${invoice.raffleId}`, 7.5, 1.2, null, 'right');

    // Client Name
    this.doc.setTextColor('#44688B');
    this.doc.text('Client Name:', 0.7, 2.4, null, 'left');
    this.doc.setTextColor('#474747');
    this.doc.text(`${profile.firstName} ${profile.lastName}`, 1.97, 2.4, null, 'left');
    // Organization Name
    this.doc.setTextColor('#44688B');
    this.doc.text('Organization Name:', 0.7, 2.7, null, 'left');
    this.doc.setTextColor('#474747');
    this.doc.text(invoice.orgName, 2.54, 2.7, null, 'left');
    // Location
    this.doc.setTextColor('#44688B');
    this.doc.text('Located In:', 0.7, 3, null, 'left');
    this.doc.setTextColor('#474747');
    this.doc.text(`${province.name}, ${country.name}`, 1.8, 3, null, 'left');

    // Raffle Info Section
    // Raffle Name
    this.doc.setTextColor('#44688B');
    this.doc.setFont('helvetica', 'bold');
    this.doc.text('Receipt for Raffle Name:', 0.7, 3.6, null, 'left');
    this.doc.setTextColor('#474747');
    this.doc.setFont('helvetica', 'normal');
    this.doc.text(this.truncateString(invoice.raffleName), 3.1, 3.6, null, 'left');

    let y = 3.9;
    if (invoice.onlineTotalSales > 0) {
      // Total Sales
      this.doc.setTextColor('#44688B');
      this.doc.setFont('helvetica', 'bold');
      this.doc.text('Online Sales:', 0.7, y, null, 'left');
      this.doc.setTextColor('#474747');
      this.doc.setFont('helvetica', 'normal');
      this.doc.text(`$${CurrencyHelper.convertToDollar(invoice.onlineTotalSales)}`, 2.0, y, null, 'left');
      y += 0.3;
    }
    if (invoice.offlineTotalSales > 0) {
      // Total Sales
      this.doc.setTextColor('#44688B');
      this.doc.setFont('helvetica', 'bold');
      this.doc.text('Offline Sales:', 0.7, y, null, 'left');
      this.doc.setTextColor('#474747');
      this.doc.setFont('helvetica', 'normal');
      this.doc.text(`$${CurrencyHelper.convertToDollar(invoice.offlineTotalSales)}`, 2.0, y, null, 'left');
      y += 0.3;
    }
    // Sales End Date
    this.doc.setTextColor('#44688B');
    this.doc.setFont('helvetica', 'bold');
    this.doc.text('Sales Ended:', 0.7, y, null, 'left');
    this.doc.setTextColor('#474747');
    this.doc.setFont('helvetica', 'normal');
    this.doc.text(DateTimeHelper.formatDateShort(new Date(invoice.saleEnd)), 2.06, y, null, 'left');

    // RR Fee
    this.doc.setTextColor('#44688B');
    this.doc.text('Platform Fee:', 4.89, 5.3, null, 'left');
    this.doc.setTextColor('#474747');
    this.doc.text(`$${CurrencyHelper.convertToDollar(invoice.fee)}`, 7.3, 5.3, null, 'right');

    // Dynamic Section
    // loop through all applicable taxes and add them while incrementing the y values
    y = 5.7;
    invoice.taxes.forEach(tax => {
      if (tax.value > 0) {
        this.doc.setTextColor('#44688B');
        this.doc.text(`${tax.name}:`, 5.6, y, null, 'left');
        this.doc.setTextColor('#474747');
        this.doc.text(`$${CurrencyHelper.convertToDollar(tax.value)}`, 7.3, y, null, 'right');
        y = +(y + 0.4).toFixed(1);
      }
    });
    // Total Paid To RR
    this.doc.setTextColor('#44688B');
    this.doc.setFont('helvetica', 'bold');
    this.doc.text('Total Amount Paid:', 4.27, y, null, 'left');
    this.doc.setFontSize(16);
    this.doc.setTextColor('#474747');
    this.doc.text(`$${CurrencyHelper.convertToDollar(invoice.totalPaid)}`, 7.3, y, null, 'right');
    this.doc.setFont('helvetica', 'normal');

    // Raffle Rocket Info Section
    this.doc.setFontSize(12);
    this.doc.setTextColor('#44688B');
    this.doc.text('Thank you for your business!', 4, 8.4, null, 'center');
    this.doc.textWithLink('www.raffle-rocket.com | support@raffle-rocket.com ', 4, 8.7, 'center');
    this.doc.setFontSize(10);
    this.doc.setTextColor('#474747');
    this.doc.text('GST/HST Registration NO.: 771510666RT0001', 4, 9, null, 'center');


    this.doc.setFont('helvetica', 'bold');
    this.doc.text('Due to rounding, numbers presented throughout this and other documents may not add up precisely', 4, 10.1, null, 'center');
    this.doc.text('to the totals provided and percentages may not precisely reflect the absolute figures.', 4, 10.3, null, 'center');
    const fileName = `${invoice.raffleName.replace(/\s+/g, '-')}.pdf`;
    this.doc.save(fileName);

  }

  private async loadData() {
    try {
      this.busy = true;
      this.invoices = await Invoice.fetch();
    } catch (error) {
      console.error('Error getting invoices', error);
      ServiceHelper.displayAlert('Error Getting Invoices', error);
    } finally {
      this.busy = false;
    }
  }

  private truncateString(text: string) {
    if (text.length > 45) {
      return `${text.slice(0, 45)}...`;
    }
    return text;
  }

}
